import {Component, OnInit} from '@angular/core';
import {NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AdminService} from "../../../../../services/admin.service";
import {UserQualificationsService} from "../../services/user-qualifications.service";

@Component({
  selector: 'app-set-level',
  templateUrl: './set-level.component.html',
  styleUrls: ['./set-level.component.css']
})
export class SetLevelComponent implements OnInit {

  levels = [1, 2, 3, 4, 5, 6];
  selectedLevel = 'Select level';
  operationSuccess = false;
  operationFail = false;
  deniedAccess = false;
  savedLevel: number;

  constructor(private modalService: NgbModal,
              public activeModal: NgbActiveModal,
              private adminService: AdminService,
              public userQualificationsServ: UserQualificationsService
  ) {
  }

  ngOnInit() {

  }

  closeAlert() {
    this.operationSuccess = false;
    this.operationFail = false;
  }

  isSetBtnDisabled(level) {
    return level === 'Select level';
  }

  selectLevel(level) {
    this.selectedLevel = level;
  }

  setSpecializationLevel(savedLevel: number) {
    this.savedLevel = savedLevel;
    this.adminService.setQualificationLevel(this.userQualificationsServ.nodeId,
      this.userQualificationsServ.userId, this.savedLevel).subscribe(
      (response: any) => {
        this.userQualificationsServ.selectedNode.data.level = response.body.levels;
        this.userQualificationsServ.selectedNode.data.date = response.body.date[0] +
          '-' + response.body.date[1] + '-' + response.body.date[2];
        this.operationSuccess = true;
        this.operationFail = false;
      },
      (err) => {
        if (err.status === 400) {
          this.deniedAccess = true;
        } else {
          this.operationSuccess = false;
          this.operationFail = true;
        }
      }
    );
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/common/qualifications/components/set-level/set-level.component.ts